Namespace 'Monitoring.Views'

class Monitoring.Views.RuleEditView extends Backbone.View
  template: JST["backbone/templates/monitoring/rules/rule_edit_modal"]

  events:
    'click .cancel': 'onClickCancel'
    'click .save': 'onClickSave'

  initialize: (@options = {}) ->
    @rule                 = @options.rule
    @availableTopics      = @options.availableTopics
    @availableTags        = @options.availableTags
    @availableGroups      = @options.availableGroups
    @availableSubtypes    = @options.availableSubtypes
    @availableUserProfileTags = @options.availableUserProfileTags
    @availableSentiments  = @options.availableSentiments
    @currentUser          = @options.currentUser
    @action_type          = @options.action_type
    @availableModerationDecision = @options.availableModerationDecision
    @noOtherTags          = @options.noOtherTags
    @newsFilterAllowed    = @options.newsFilterAllowed
    @showLocation         = @options.showLocation

  render: ->
    @$el.html(@template())
    @renderGeneralTab()
    @renderScConditionTab()
    @renderActionsTab()

    @initializeModal()
    @initializeChosen()
    @updateSaveButtonStatus()
    @

  renderGeneralTab: ->
    @ruleGeneralEditView = new Monitoring.Views.RuleGeneralEditView({
      rule: @rule
    })
    @$el.find('.tab-content #general').html(@ruleGeneralEditView.render().el)
    @listenTo(@ruleGeneralEditView, 'changed-mandatory-field', @updateSaveButtonStatus)

  renderScConditionTab: ->
    @scConditionEditView = new Monitoring.Views.SocialContentConditionEditView({
      socialContentCondition: @rule.get('social_content_condition')
      availableTopics: @availableTopics
      availableTags: @availableTags
      availableGroups: @availableGroups
      availableSubtypes: @availableSubtypes
      availableSentiments: @availableSentiments
      noOtherTags: @noOtherTags
      newsFilterAllowed: @newsFilterAllowed
      showLocation: @showLocation
      editView: @$el
    })
    @$el.find('.tab-content #sc-condition').html(@scConditionEditView.render().el)
    @listenTo(@scConditionEditView, 'changed-mandatory-field', @updateSaveButtonStatus)

  renderActionsTab: ->
    if @action_type == 'social_content_action'
      @renderSocialContentActionsTab()
    else
      @renderProfileActionsTab()
    @$el.find('.tab-content #actions').html(@actionsEditView.render().el)
    @listenTo(@actionsEditView, 'changed-mandatory-field', @updateSaveButtonStatus)

  renderSocialContentActionsTab: ->
    @actionsEditView = new Monitoring.Views.SocialContentActionsEditView
      addTagToSocialContentAction: @rule.get('actions')['add_tag_to_social_content']
      removeTagFromSocialContentAction: @rule.get('actions')['remove_tag_from_social_content']
      removeAllTagsFromSocialContentAction: @rule.get('actions')['remove_all_tags_from_social_content'] || false
      addLabelToSocialContentAction: @rule.get('actions')['add_label_to_social_content']
      inheritGroupFromParent: @rule.get('actions')['inherit_group_from_parent']
      removeLabelfromSocialContentAction: @rule.get('actions')['remove_label_from_social_content']
      addSentimentToSocialContentAction: @rule.get('actions')['add_sentiment_to_social_content']
      addModerationDecisionToSocialContentAction: @rule.get('actions')['add_moderation_decision_to_social_content']
      availableTags: @availableTags
      availableGroups: @availableGroups
      availableSentiments: @availableSentiments
      availableModerationDecision: @availableModerationDecision

  renderProfileActionsTab: ->
    tag_to_user_profile_actions_default = [{ user_profile_tag: {} }]
    tag_to_user_profile_actions = @rule.get('actions')["add_tag_to_user_profile"] || tag_to_user_profile_actions_default
    if tag_to_user_profile_actions.length == 0
      tag_to_user_profile_actions = tag_to_user_profile_actions_default
    @actionsEditView = new Monitoring.Views.ProfileActionsEditView({
      addTagToUserProfileAction: tag_to_user_profile_actions[0] # TODO: select based on type
      availableUserProfileTags: @availableUserProfileTags
    })

  viewsInTabs: ->
    [@ruleGeneralEditView, @scConditionEditView, @actionsEditView]

  initializeModal: ->
    $.fn.modal.Constructor.prototype.enforceFocus = ->
    @$el.find('#rule-edit-modal').modal()

  initializeChosen: ->
    @$el.find('.chosen-select').chosen({
      width: '395px'
      enable_split_word_search: true
      search_contains: true
    }).on('chosen:showing_dropdown', @_closeOpenChosen)

  # https://github.com/harvesthq/chosen/issues/2980
  _closeOpenChosen: (event) =>
    @$el.find(".social-content-actions select").not("##{event.currentTarget.id}").trigger('chosen:close')

  updateSaveButtonStatus: =>
    @$el.find('.save').prop('disabled', !@allMandatoryFieldsAreFilled())

  allMandatoryFieldsAreFilled: =>
    _.all(@viewsInTabs(), (view) -> view.allMandatoryFieldsAreFilled())

  onClickCancel: ->
    @trigger('cancel')
    @deleteBackdrops()

  onClickSave: ->
    @rule.set('social_content_condition', @scConditionEditView.getCondition())
    @rule.set('actions', @actionsEditView.getActions())
    @rule.set('updated_at', new Date().toISOString())
    @rule.set('last_updated_by', @currentUser)

    errorOrValid = @rule.validateFields()
    if errorOrValid == "VALID"
      @$el.find('.saving').removeClass('invalid-fields').html('Saving...').show()
      @rule.save({}, {
        success: (response) =>
          @$el.find('#rule-edit-modal').modal('hide')
          @trigger('afterSave', @checkedRule())
          @deleteBackdrops()
        error: (response) =>
          @$el.find('.saving').html('Error')
          console.log("Error saving rule: #{response}")
      })
    else
      @$el.find('.saving').addClass('invalid-fields').html(errorOrValid).show()

  deleteBackdrops: ->
    backdrops = document.getElementsByClassName("modal-backdrop")
    while  backdrops.length > 0
      backdrops[0].remove()

  checkedRule: ->
    actions = @rule.attributes.actions
    @rule.attributes['actions'] = {}
    if @action_type == 'social_content_action'
      for i in [0...actions.length]
        @rule.attributes.actions[actions[i].type] = actions[i].name
    else if @action_type == 'profile_action'
      @rule.attributes.actions[actions[0].type] = actions
    else
      @rule.attributes.actions = actions
    @rule
